import { Globe, Palette } from "lucide-react";
import { useTranslation } from "react-i18next";
import { SettingCard } from "@/components/settings/setting-card";
import { SettingField } from "@/components/settings/setting-field";
import { ThemeSelect } from "@/components/ui/theme-toggle";
import { FullLanguageSelector } from "@/lib/components/i18n/language-selector";

export function AppearanceForm() {
  const { t } = useTranslation("settings");

  return (
    <div className="space-y-6">
      {/* Theme Preferences */}
      <SettingCard
        title={t("appearance.fields.theme.label")}
        icon={<Palette className="h-5 w-5" />}
      >
        <SettingField
          label={t("appearance.fields.theme.label")}
          helpText={t("appearance.fields.theme.helpText")}
          helpDetails={
            <div className="space-y-2">
              <div className="text-sm font-medium text-foreground">
                {t("appearance.fields.theme.helpDetails.title")}
              </div>
              <ul className="text-sm space-y-1 text-muted-foreground">
                {(
                  t("appearance.fields.theme.helpDetails.benefits", {
                    returnObjects: true,
                  }) as string[]
                ).map((benefit: string, index: number) => (
                  <li key={index}>• {benefit}</li>
                ))}
              </ul>
            </div>
          }
        >
          <ThemeSelect />
        </SettingField>
      </SettingCard>

      {/* Language Preferences */}
      <SettingCard
        title={t("appearance.fields.language.label")}
        icon={<Globe className="h-5 w-5" />}
      >
        <SettingField
          label={t("appearance.fields.language.label")}
          helpText={t("appearance.fields.language.helpText")}
          helpDetails={
            <div className="space-y-2">
              <div className="text-sm font-medium text-foreground">
                {t("appearance.fields.language.helpDetails.title")}
              </div>
              <ul className="text-sm space-y-1 text-muted-foreground">
                {(
                  t("appearance.fields.language.helpDetails.benefits", {
                    returnObjects: true,
                  }) as string[]
                ).map((benefit: string, index: number) => (
                  <li key={index}>• {benefit}</li>
                ))}
              </ul>
            </div>
          }
        >
          <FullLanguageSelector />
        </SettingField>
      </SettingCard>
    </div>
  );
}
